import { UpdateProfessionalApprovalDTO } from "@/domain/dto/UpdateProfessionalApprovalDTO";
import { IProfessionalRepository } from "@/domain/repositories/IProfessionalRepository";
import { IUpdateProfessionalApprovalUseCase } from "@/domain/usecases/IUpdateProfessionalApprovalUseCase";

export class UpdateProfessionalApprovalUseCase implements IUpdateProfessionalApprovalUseCase {
    repository: IProfessionalRepository
    constructor(repository: IProfessionalRepository) {
        this.repository = repository
    }
    async execute(params: UpdateProfessionalApprovalDTO): Promise<void> {
        return this.repository.updateApproval(params)
    }
}
